import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyStart: {
        id: 'policycommon.component.policy-common-details.Policy Start',
        defaultMessage: 'Policy Start'
    },
    PolicyExpiration: {
        id: 'policycommon.component.policy-common-details.Policy Expiration',
        defaultMessage: 'Policy Expiration'
    },
    PolicyType: {
        id: 'policycommon.component.policy-common-details.Policy Type',
        defaultMessage: 'Policy Type'
    },
    RiskManagement: {
        id: 'policycommon.component.policy-common-details.Risk Management',
        defaultMessage: 'Risk Management Discount'
    },
    RiskManagementExpires: {
        id: 'policycommon.component.policy-common-details.Risk Management Expires',
        defaultMessage: 'Risk Management Expires'
    },
    MultiLineDiscount: {
        id: 'policycommon.component.policy-common-details.MultiLineDiscount',
        defaultMessage: 'Multi-Line Discount'
    },
    DiscountInfo: {
        id: 'policycommon.component.policy-common-details.For more information on available discounts',
        defaultMessage: 'For more information on available discounts'
    },
    ContactAgent: {
        id: 'policycommon.component.policy-common-details.Contact your agent or visit',
        defaultMessage: 'Contact your agent or  visit'
    },
    MultiLineAgent: {
        id: 'tdic.policycommon.component.policy-common-details.Contact your agent to bundle and save with a full suite of TDIC products.',
        defaultMessage: 'Contact your agent to bundle and save with a full suite of TDIC products.'
    },
    IndoLink: {
        id: 'tdic.riskmanagment.detail.www.tdicinsurance.com/Seminars',
        defaultMessage: 'www.tdicinsurance.com/Seminars'
    },
    TotalPremium: {
        id: 'policycommon.component.policy-common-details.Total Premium',
        defaultMessage: 'Total Premium'
    },
    TaxesAndFees: {
        id: 'policycommon.component.policy-common-details.Taxes and Fees',
        defaultMessage: 'Taxes and Fees'
    },
    TotalCost: {
        id: 'policycommon.component.policy-common-details.Total Cost',
        defaultMessage: 'Total Cost'
    },
    details: {
        id: 'policycommon.component.policy-common-details.Details',
        defaultMessage: 'Details'
    },
    premium: {
        id: 'policycommon.component.policy-common-details.Premium',
        defaultMessage: 'Premium'
    },
    discountTitleText: {
        id: 'tdic.policycommon.component.policy-common-details.Your premium reflects the following discounts:',
        defaultMessage: 'Your premium reflects the following discounts:'
    },
    Specialty: {
        id: 'tdic.policycommon.component.policy-common-details.Specialty',
        defaultMessage: 'Specialty'
    },
    odaMembershipDiscount: {
        id: 'tdic.policycommon.component.policy-common-details.Oda membership discount',
        defaultMessage: 'ODA Membership Discount'
    },
    StateDentalAssocMemberDiscount: {
        id: 'tdic.policycommon.component.policy-common-details.State Dental Assoc Member Discount',
        defaultMessage: 'State Dental Assoc Member Discount'
    },

});
